import { useState, useEffect } from 'react';
import { dockerService } from '../services/dockerService';

/**
 * useContainerStats Hook
 * Polls container stats at regular intervals
 * @param {string} containerId - Container ID to monitor
 * @param {boolean} enabled - Whether polling is enabled
 * @param {number} interval - Polling interval in milliseconds
 */
export function useContainerStats(containerId, enabled = true, interval = 3000) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !containerId) {
      return;
    }

    let cancelled = false;

    const fetchStats = async () => {
      try {
        const data = await dockerService.getContainerStats(containerId);
        if (!cancelled) {
          setStats(data);
          setLoading(false);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Error fetching stats:', err);
          setError(err.message);
          setLoading(false);
        }
      }
    };

    // Initial fetch
    fetchStats();

    // Setup polling
    const intervalId = setInterval(fetchStats, interval);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [containerId, enabled, interval]);

  return { stats, loading, error };
}
